import { render } from "./Footnotes.vue?vue&type=template&id=5cf32b40&scoped=true&lang=pug"
import script from "./Footnotes.vue?vue&type=script&setup=true&lang=js"
export * from "./Footnotes.vue?vue&type=script&setup=true&lang=js"

import "./Footnotes.vue?vue&type=style&index=0&id=5cf32b40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf32b40"]])

export default __exports__